import styled from 'styled-components';

export const Wrapper = styled.div`

.sucursales-container .subtitle {
	color: #383838;
	font-family: Ubuntu;
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 20px;
	margin-bottom: 8px;
}

.formulario-sucursal{
  display: flex;
    gap: 30px;
}

.formulario-comuna{
  width: 100%;
}

.AccordionItem--content {
	p:first-of-type {
		font-size: 0.8rem;
	}
	p {
		font-size: 0.8rem;
	}
	span {
		font-weight: bold;
	}
}

.Autocomplete-selector input {
	font-size: 0.8rem;
}

form ._2lUSM {
	margin-bottom: 15px;
}

._3pNgQ._E_S3q h1 {
	font-size: 1.5rem;
}

._3sTov {
	border-radius: 5px;
	border: 1px solid #d4d4d4;
}

._sqrUW {
	color: #383838;
	font-family: Ubuntu;
	font-weight: bold;
	letter-spacing: 0;
}

._3pNgQ ._3b-4_ ._sqrUW {
	font-size: 18px;
	line-height: 24px;
}

._3pNgQ._E_S3q ._3l2PK {
	margin-left: -1rem;
	margin-right: -1rem;
}

.Autocomplete-selector {
	margin-bottom: 28px;
}

.Autocomplete-selector label {
	color: #383838;
	font-family: Ubuntu;
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 20px;
	margin-bottom: 8px;
}

.Autocomplete-selector .Autocomplete-list li {
	font-size: 0.8rem;
}

.Autocomplete-selector_mobile {
	background: white;
	height: inherit;
	position: relative;
	width: 100%;
	top: inherit;
	left: inherit;
	right: inherit;
	z-index: 10;
}

.Autocomplete-selector_mobile label {
	position: unset;
	top: 10px;
	left: 5px;
	width: inherit;
	padding-top: inherit;
	padding-left: inherit;
	background: white;
	z-index: inherit;
	/* font-size: inherit; */
}

.Autocomplete-selector_mobile .Autocomplete-input-wrapper {
	position: relative;
	top: inherit;
	width: inherit;
	z-index: 20;
}

.Autocomplete-selector_mobile input {
	width: 100%;
	border-radius: 4px;
}

.Autocomplete-selector_mobile .Autocomplete-container {
	position: unset;
	/* max-height: 100%; */
	/* overflow-y: scroll !important; */
}

.Autocomplete-selector_mobile .Autocomplete-list {
	position: absolute;
	width: 100%;
	top: 72px;
	max-height: calc(var(--height-max-row) * 5);
	height: inherit;
	box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 5%), 0px 8px 10px 1px rgb(0 0 0 / 10%), 0px 3px 14px 2px rgb(0 0 0 / 10%);
	z-index: 10;
	overflow-y: auto;
}

@media (max-width: 480px) {
	._3pNgQ._E_S3q h1 {
		font-size: 1.2rem;
	}
  .formulario-sucursal{
    display: block;
  }
	._3pNgQ._E_S3q h1 {
		font-size: 1.1rem;
	}
	.Autocomplete-selector label {
		font-size: 0.8rem;
	}
	.Autocomplete-selector .Autocomplete-list li {
		font-size: 0.7rem;
	}
	.Autocomplete-selector{
    input{
		  font-size: 0.7rem;
      line-height: 15px;
    }
	}
	.RadioButton p {
		font-size: 0.8rem;
	}
	.direccion {
		font-size: 0.8rem;
		margin-top: 0 !important;
	}
	.AccordionItem--content p:first-of-type {
		font-size: 0.7rem;
	}
	.AccordionItem--content p {
		font-size: 0.7rem;
	}
}

@media (max-width: 320px) {
	._3pNgQ._E_S3q h1 {
		font-size: 1rem;
	}
  .formulario-sucursal{
    display: block;
  }
	.Autocomplete-selector label {
		font-size: 0.8rem;
	}
	.Autocomplete-selector .Autocomplete-list li {
		font-size: 0.7rem;
	}
	.Autocomplete-selector{
    input {
      font-size: 0.7rem;
      line-height: 15px;
    }
	}
	.RadioButton p {
		font-size: 0.7rem;
	}
	.direccion {
		font-size: 0.7rem;
		margin-top: 0 !important;
	}
	.AccordionItem--content 
     p:first-of-type {
		  font-size: 0.7rem;
     }
     p{
      font-size: 0.7rem;
     } 
	}
}   
`;

export default Wrapper;